import Header from "../components/common/Header";
import Footer from "../components/common/Footer";
import ResidentForm from "../components/Resident/Residentform";
import DraggableProfilePanel from "../components/common/DraggableProfilePanel";

function Resident () {
    return(
        <>
        <div className="parent-container">
            <div className="container">
                <div className="header-class">
                    <Header isVisible={true} buttonsVisible={true}/>
                </div>
                <div className="content-class">
                    <DraggableProfilePanel/>
                    <ResidentForm></ResidentForm>
                </div>
                <div className="footer-class">
                    <Footer />
                </div>
            </div>
        </div>
        </>
    )
}

export default Resident;